module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("SECTION I")])])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Killing and the Existence of the Resistance: A World of Virgins Studying Sex")])])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It is therefore reasonable to believe that the average and healthy individual—the man who can endure the mental and physical stresses of combat—still has such an inner and usually unrealized resistance towards killing a fellow man that he will not of his own volition take life if it is possible to turn away from that responsibility…. At the vital point he becomes a conscientious objector.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("—S. L. A. Marshall")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Men Against Fire")])])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i')])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Then I cautiously raised the upper half of my body into the tunnel until I was lying flat on my stomach. When I felt comfortable, I placed my Smith Wesson .38-caliber snub-nose (sent to me by my father for tunnel work) beside the flashlight and switched on the light, illuminating the tunnel.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There, not more than 15 feet away, sat a Viet Cong eating a handful of rice from a pouch on his lap. We looked at each other for what seemed to be an eternity, but in fact was probably only a few seconds.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Maybe it was the surprise of actually finding someone else there, or maybe it was just the absolute innocence of the situation, but neither one of us reacted.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("After a moment, he put his pouch of rice on the floor of the tunnel beside him, turned his back to me and slowly started crawling away. I, in turn, switched off my flashlight, before slipping back into the lower tunnel and making my way back to the entrance. About 20 minutes later, we received word that another squad had killed a VC emerging from a tunnel 500 meters away.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I never doubted who that VC was. To this day, I firmly believe that grunt and I could have ended the war sooner over a beer in Saigon than Henry Kissinger ever could by attending the peace talks.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("—Michael Kathman")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Triangle Tunnel Rat”")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Our first step in the study of killing is to understand the existence, extent, and nature of the average human being’s resistance to killing his fellow human. In this section we will attempt to do that.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("When I started interviewing combat veterans as a part of this study, I discussed some of the psychological theories concerning the trauma of combat with one crusty old sergeant. He laughed scornfully and said, “Those bastards don’t know anything about it. They’re like a world of virgins studying sex, and they got nothing to go on but porno movies. And it "), _c('i', [_vm._v("is")]), _vm._v(" just like sex, ’cause the people who "), _c('i', [_vm._v("really")]), _vm._v(" do it just don’t talk about it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("In a way, the study of killing in combat is very much like the study of sex. Killing is a private, intimate occurrence of tremendous intensity, in which the destructive act becomes psychologically very much like the procreative act. For those who have never experienced it, the depiction of battle that Hollywood has given us, and the cultural mythology that Hollywood is based upon, appear to be about as useful in understanding killing as pornographic movies would be in trying to understand the intimacy of a sexual relationship. A virgin observer might get the mechanics of sex right by watching an X-rated movie, but he or she could never hope to understand the intimacy and intensity of the procreative experience.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("As a society we are as fascinated by killing as we are by sex—possibly more so, since we are somewhat jaded by sex and have a fairly broad base of individual experience in this area. Many children, upon seeing that I am a decorated soldier, immediately ask “Have you ever killed anyone?” or “How many people have you killed?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Where does this curiosity come from? Robert Heinlein once wrote that fulfillment in life involved “loving a good woman and killing a bad man.” If there is such a strong interest in killing in our society, and if it equates in many minds to an act of manhood equivalent to sex, then why hasn’t the destructive act been as specifically and systematically studied as the procreative act?")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Over the centuries there have been a few pioneers who have laid the foundation for such a study, and in this section we will attempt to look at them all. Probably the best starting point is with S. L. A. Marshall, the greatest and most influential of these pioneers.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Prior to World War II it had always been assumed that the average soldier would kill in combat simply because his country and his leaders had told him to do so and because it was essential to defend his own life and the lives of his friends. When the point came that he didn’t kill, it was assumed that he panicked and ran.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("During World War II U.S. Army Brigadier General S. L. A. Marshall asked these average soldiers what it was that they did in battle. His singularly unexpected discovery was that, of every hundred men along the line of fire during the period of an encounter, an average of only 15 to 20 “would take any part with their weapons.” This was consistently true “whether the action was spread over a day, or two days or three.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Marshall was a U.S. Army historian in the Pacific theater during World War II and later became the official U.S. historian of the European theater of operations. He had a team of historians working for him, and they based their findings on individual and mass interviews with thousands of soldiers in more than four hundred infantry companies, in Europe and in the Pacific, immediately after they had been in close combat with German or Japanese troops. The results were consistently the same: only 15 to 20 percent of the American riflemen in combat during World War II would fire at the enemy. Those who would not fire did not run or hide (in many cases they were willing to risk great danger to rescue comrades, get ammunition, or run messages), but they simply would not fire their weapons at the enemy, even when faced with repeated waves of banzai charges."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/section55#sn1_1",
      "id": "sn1-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[1]")])])])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The question is why. Why did these men fail to fire? As I examined this question and studied the process of killing in combat from the standpoints of a historian, a psychologist, and a soldier, I began to realize that there was one major factor that was missing from the common understanding of killing in combat, a factor that answers this question and more. That missing factor is the simple and demonstrable fact that there is within most men an intense resistance to killing their fellow man. A resistance so strong that, in many circumstances, soldiers on the battlefield will die before they can overcome it.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("To some, this makes “obvious” sense. “Of course it is hard to kill someone,” they would say. “I could never bring myself to do it.” But they would be wrong. With the proper conditioning and the proper circumstances, it appears that almost anyone can and will kill. Others might respond, “Any man will kill in combat when he is faced with someone who is trying to kill him.” And they would be even more wrong, for in this section we shall observe that throughout history the majority of men on the battlefield would "), _c('i', [_vm._v("not")]), _vm._v(" attempt to kill the enemy, even to save their own lives or the lives of their friends.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ea39274","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section6.vue
// module id = 81
// module chunks = 0